import dom from '../../../wrapper/DomWrapper';

import defaultImage from '../utils';
import errorHandler from './errorHandler';

const photoErrorHandler = () => {
  const selectorName = '.picture-wrap';
  const onError = (elImage, elParent) => {
    // eslint-disable-next-line no-param-reassign
    elImage.previousSibling.srcset = defaultImage;
    dom.addClass(elParent, 'picture-wrap_unavailable');
  };

  errorHandler(selectorName, onError);
};

export default photoErrorHandler;
